module.exports = __webpack_public_path__ + "img/check.1a029f7d.svg";